module.exports = __webpack_public_path__ + "img/oliver-borner.afa2cf2c.jpg";